export default __webpack_public_path__ + "static/media/eveneu.e8c9d6f2.jpg";